<template>
  <div class="qrcode-stream-wrapper">
    <div class="focus-overlay">
      <img :src="focusFrameImg" />
    </div>
    <div class="loader" v-if="showLoader">
      <v-progress-circular indeterminate size="64" color="white"></v-progress-circular>
    </div>
    <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit" :track="false"></qrcode-stream>

    <v-dialog v-model="initErrorDialog" max-width="330" persistent>
      <v-card>
        <v-card-title class="headline">{{$t('couponScan.noteTitle')}}</v-card-title>

        <v-card-text>
          {{initErrorDialogText}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="initErrorDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="timeoutErrorDialog" max-width="330" persistent>
      <v-card>
        <v-card-title class="headline">{{$t('couponScan.noteTitle')}}</v-card-title>

        <v-card-text>
          {{ $t('couponScan.rksvRequireImageValidationText') }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="cancel()">{{ $t('couponScan.errorDialogCancelButton') }}</v-btn>
          <v-btn color="primary" text @click="tryAgain()">{{$t('couponScan.tryAgain')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {QrcodeStream} from 'vue-qrcode-reader';
  import focusFrame from '@/assets/focus-frame.png';

  export default {
    name: 'QrCodeScanner',
    components: {QrcodeStream},
    data() {
      return {
        isValid: undefined,
        camera: 'auto',
        result: null,
        focusFrameImg: focusFrame,
        waitTimeSeconds: 20,
        countDown: false,
        timeoutErrorDialog: false,
        initErrorDialog: false,
        initErrorDialogText: this.$t('couponScan.errorDialogNotAvailable'),
        showLoader: false
      }
    },
    computed: {
      validationPending() {
        return this.isValid === undefined && this.camera === 'off'
      },
      validationSuccess() {
        return this.isValid === true
      },
      validationFailure() {
        return this.isValid === false
      }
    },
    methods: {
      async onInit(promise) {
        try {
          await promise;
          if (this.camera != 'off') {
            this.startCountdown();
          }
        } catch (error) {
          if (error.name === 'NotAllowedError') {
            this.initErrorDialogText = this.$t('couponScan.errorDialogAllowCamera')
          }
          this.initErrorDialog = true;
        }
      },
      resetValidationState() {
        this.isValid = undefined
      },
      async onDecode(content) {
        this.result = content
        this.turnCameraOff()
        this.showLoader = true;
        await this.timeout(600)
        this.sendCode(content);
      },
      sendCode(code) {
        clearInterval(this.countDown);
        this.$emit('codeScanned', code)
      },
      turnCameraOn() {
        this.camera = 'auto'
      },
      turnCameraOff() {
        this.camera = 'off'
      },
      timeout(ms) {
        return new Promise((resolve) => {
          window.setTimeout(resolve, ms)
        })
      },
      startCountdown() {
        this.countdownEnd = new Date().getTime() + this.waitTimeSeconds * 1000;
        this.countDown = setInterval(() => {
          if (this.countdownEnd - new Date().getTime() <= 0) {
            clearInterval(this.countDown);
            this.turnCameraOff();
            this.timeoutErrorDialog = true;
          }
        }, 1000);
      },
      tryAgain() {
        this.timeoutErrorDialog = false;
        this.showLoader = false;
        setTimeout(() => {
          this.turnCameraOn();
        }, 100);
      },
      cancel() {
        this.$router.push({name: 'home'});
      }
    }
  }
</script>

<style scoped lang="scss">
  .qrcode-stream-wrapper {
    height: 100%;
    background: rgba(0,0,0,.3);
    position: relative;
    width: auto;
    margin: 3em auto;
    display: flex;
    max-width: 400px;
    width: 100%;
    &:before {
      content: '';
      position: relative;
      padding-top: 100%;
    }
    &::v-deep .wrapper {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .focus-overlay {
    position: absolute;
    width: 68%;
    left: 16%;
    top: 16%;
    z-index: 2;
    &:before {
      content: "";
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      padding-top: 100%;
      display: block;
    }
    img {
      width: 100%;
      position: absolute;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
  .loader {
    position: absolute;
    z-index: 2;
    height: 100%;
    width: 100%;
    background: rgba(0,0,0,.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
